import { Chip, chipClasses } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const Wrapper = styled(Chip)`
    max-width: fit-content;

    &.${chipClasses.sizeSmall} {
        height: 30px;
    }

    &.${chipClasses.disabled} {
        opacity: 1;
        color: ${({ theme }) => theme.palette.text.disabled};
        background-color: ${({ theme }) => theme.palette.action.focus};
    }

    &.${chipClasses.colorSuccess} {
        color: ${({ theme }) => theme.palette.success.dark};
        background-color: ${({ theme }) => alpha(theme.palette.success.main, 0.3)};
    }

    &.${chipClasses.colorError} {
        color: ${({ theme }) => theme.palette.error.dark};
        background-color: ${({ theme }) => alpha(theme.palette.error.main, 0.3)};
    }

    &.${chipClasses.colorWarning} {
        color: ${({ theme }) => theme.palette.warning.dark};
        background-color: ${({ theme }) => alpha(theme.palette.warning.main, 0.3)};
    }
`;
